module.exports = __webpack_public_path__ + "img/05-boy.7af9f407.svg";